/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { CouncilOfTheApes } from "../CouncilOfTheApes";

export class CouncilOfTheApes__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _orbitalApes: string,
    overrides?: Overrides
  ): Promise<CouncilOfTheApes> {
    return super.deploy(
      _orbitalApes,
      overrides || {}
    ) as Promise<CouncilOfTheApes>;
  }
  getDeployTransaction(
    _orbitalApes: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_orbitalApes, overrides || {});
  }
  attach(address: string): CouncilOfTheApes {
    return super.attach(address) as CouncilOfTheApes;
  }
  connect(signer: Signer): CouncilOfTheApes__factory {
    return super.connect(signer) as CouncilOfTheApes__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CouncilOfTheApes {
    return new Contract(address, _abi, signerOrProvider) as CouncilOfTheApes;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_orbitalApes",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "title",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
    ],
    name: "ProposalCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "title",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
    ],
    name: "ProposalEdited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "voter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newVote",
        type: "uint256",
      },
    ],
    name: "VoteCasted",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "vote",
        type: "uint8",
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
    ],
    name: "castVote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "title",
        type: "string",
      },
      {
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
    ],
    name: "createProposal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "title",
        type: "string",
      },
      {
        internalType: "string",
        name: "description",
        type: "string",
      },
    ],
    name: "editProposal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minProposalTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "orbitalApes",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalInfo",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalStatus",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_minProposalTime",
        type: "uint256",
      },
    ],
    name: "setMinProposalTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_orbitalApes",
        type: "address",
      },
    ],
    name: "setOrbitalApesContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
